import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

const nonce = window.__NONCE__;
const emotionCache = createCache({
  key: 'css',
  nonce: nonce,
});
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
      <CacheProvider value={emotionCache}>
        <App />
      </CacheProvider>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
